import moment from "moment/moment";

export function getInitials(name) {
  if (!name) return "";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (
    parts[0].charAt(0).toUpperCase() +
    parts[parts.length - 1].charAt(0).toUpperCase()
  );
}

export function getGreeting() {
  const now = new Date();
  const hour = now.getHours();

  if (hour < 12) {
    return "Good Morning";
  } else if (hour < 18) {
    return "Good Afternoon";
  } else {
    return "Good Evening";
  }
}

export const createFormData = (employee) => {
  const formData = new FormData();

  Object.entries(employee).forEach(([key, value]) => {
    if (key === "employee_image") {
      if (Array.isArray(value) && value.length > 0) {
        formData.append("employee_image", value[0]); // send first file
      }
    } else if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return formData;
};

export const createCandidateFormData = (employee) => {
  const formData = new FormData();

  Object.entries(employee).forEach(([key, value]) => {
    if (key === "resume") {
      if (Array.isArray(value) && value.length > 0) {
        formData.append("resume", value[0]); // send first file
      }
    } else if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return formData;
};

export function formatCurrency(amount) {
  return Number(amount).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export const createLeaveFormData = (data) => {
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (key === "medical_certificate") {
      if (Array.isArray(value) && value.length > 0) {
        formData.append("medical_certificate", value[0]); // send first file
      }
    } else if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  // To debug contents:
  for (let [key, val] of formData.entries()) {
    console.log(key, val);
  }

  return formData;
};

export function extractKeys(data) {
  return data.map((item) => item.key);
}

export function extractPermissionIds(data) {
  return data.map((item) => item.id);
}

export function getFileType(fileUrl) {
  if (!fileUrl || typeof fileUrl !== "string") return null;

  const parts = fileUrl.split(".");
  if (parts.length < 2) return null;

  return parts.pop().toLowerCase(); // get last part after '.'
}

export function getSortedData(data) {
  return [...data] // copy so you don’t mutate original
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    .slice(0, 10);
}

export function parseLocalTime(timeStr) {
  if (!timeStr) return null;
  return moment(timeStr, "YYYY-MM-DDTHH:mm:ss").toDate().getTime();
}

export function getAttendanceStatus(checkInMoment, location_id) {
  const scheduled = checkInMoment.clone().set({
    hour: location_id === 1 ? 9 : 10,
    minute: location_id === 1 ? 30 : 30,
    second: 0,
    millisecond: 0,
  });

  const onePM = checkInMoment.clone().set({
    hour: 13,
    minute: 0,
    second: 0,
    millisecond: 0,
  });

  const diffMinutes = checkInMoment.diff(scheduled, "minutes");

  if (checkInMoment.isAfter(onePM)) {
    return "half_day";
  } else if (diffMinutes >= 16) {
    return "late";
  } else {
    return "on_time";
  }
}

export function capitalCase(inputString) {
  // Split the string into words, capitalize the first letter of each, and join them back together
  return inputString
    .split(" ") // Split the string into words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
    .join(" "); // Join the words back into a single string
}

export function timeAgo(dateString) {
  const now = new Date();
  const past = new Date(dateString);
  const diffInSeconds = Math.floor((now - past) / 1000);

  const intervals = [
    { label: "year", seconds: 31536000 },
    { label: "month", seconds: 2592000 },
    { label: "week", seconds: 604800 },
    { label: "day", seconds: 86400 },
    { label: "hour", seconds: 3600 },
    { label: "minute", seconds: 60 },
    { label: "second", seconds: 1 },
  ];

  for (const interval of intervals) {
    const count = Math.floor(diffInSeconds / interval.seconds);
    if (count > 0) {
      return `${count} ${interval.label}${count !== 1 ? "s" : ""} ago`;
    }
  }
  return "just now";
}

export const documentTypes = [
  {
    label: "Government Personal ID",
    value: "Government Personal ID",
    location_id: [1, 2],
  },
  { label: "Latest CV", value: "Latest CV", location_id: [1, 2] },
  {
    label: "Parents/Spouse ID",
    value: "Parents/Spouse ID",
    location_id: [1, 2],
  },
  {
    label: "Bank Passbook Photo",
    value: "Bank Passbook Photo",
    location_id: [1, 2],
  },
  {
    label: "Experience Certificate",
    value: "Experience Certificate",
    location_id: [1, 2],
  },
  {
    label: "Last Three Months salary slip",
    value: "Last Three Months salary slip",
    location_id: [1, 2],
  },
  { label: "10th Certificate", value: "10th Certificate", location_id: [1, 2] },
  { label: "+2 Certificate", value: "+2 Certificate", location_id: [1, 2] },
  {
    label: "Graduation Certificate",
    value: "Graduation Certificate",
    location_id: [1, 2],
  },
  {
    label: "Post Graduation Certificate",
    value: "Post Graduation Certificate",
    location_id: [1, 2],
  },
  {
    label: "Signed Offer Letter",
    value: "Signed Offer Letter",
    location_id: [1, 2],
  },

  // UAE only
  { label: "Passport", value: "Passport", location_id: [1] },
  { label: "Emirates ID", value: "Emirates ID", location_id: [1] },
  { label: "Visa", value: "Visa", location_id: [1] },
  {
    label: "Approved Labor Contract",
    value: "Approved Labor Contract",
    location_id: [1],
  },
  {
    label: "Other",
    value: "Other",
    location_id: [1, 2],
  },
];

const leaveSubTypeOptions = [
  { label: "Full Day", value: "full_day" },
  { label: "First Half", value: "first_half" },
  { label: "Second Half", value: "second_half" },
  { label: "Short Leave", value: "short_leave" },
];

export function getLeaveLabel(value) {
  const option = leaveSubTypeOptions.find((item) => item.value === value);
  return option ? option.label : "";
}

export function convertOlToUlByDataList(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  // Select all <ol> elements
  const olElements = doc.querySelectorAll("ol");

  olElements.forEach((ol) => {
    const liItems = ol.querySelectorAll("li");

    // Check if all <li> inside have data-list="bullet"
    const isBulletList = Array.from(liItems).every(
      (li) => li.getAttribute("data-list") === "bullet"
    );

    if (isBulletList) {
      const ul = document.createElement("ul");
      // Move all <li> elements to the new <ul>
      liItems.forEach((li) => ul.appendChild(li.cloneNode(true)));
      // Replace <ol> with <ul>
      ol.replaceWith(ul);
    }
  });

  return doc.body.innerHTML;
}

export function getCountryList() {
  return [
    { label: "Afghan", value: "Afghan" },
    { label: "Albanian", value: "Albanian" },
    { label: "Algerian", value: "Algerian" },
    { label: "American", value: "American" },
    { label: "Andorran", value: "Andorran" },
    { label: "Angolan", value: "Angolan" },
    { label: "Antiguans", value: "Antiguans" },
    { label: "Argentinean", value: "Argentinean" },
    { label: "Armenian", value: "Armenian" },
    { label: "Australian", value: "Australian" },
    { label: "Austrian", value: "Austrian" },
    { label: "Azerbaijani", value: "Azerbaijani" },
    { label: "Bahamian", value: "Bahamian" },
    { label: "Bahraini", value: "Bahraini" },
    { label: "Bangladeshi", value: "Bangladeshi" },
    { label: "Barbadian", value: "Barbadian" },
    { label: "Barbudans", value: "Barbudans" },
    { label: "Batswana", value: "Batswana" },
    { label: "Belarusian", value: "Belarusian" },
    { label: "Belgian", value: "Belgian" },
    { label: "Belizean", value: "Belizean" },
    { label: "Beninese", value: "Beninese" },
    { label: "Bhutanese", value: "Bhutanese" },
    { label: "Bolivian", value: "Bolivian" },
    { label: "Bosnian", value: "Bosnian" },
    { label: "Brazilian", value: "Brazilian" },
    { label: "British", value: "British" },
    { label: "Bruneian", value: "Bruneian" },
    { label: "Bulgarian", value: "Bulgarian" },
    { label: "Burkinabe", value: "Burkinabe" },
    { label: "Burmese", value: "Burmese" },
    { label: "Burundian", value: "Burundian" },
    { label: "Cambodian", value: "Cambodian" },
    { label: "Cameroonian", value: "Cameroonian" },
    { label: "Canadian", value: "Canadian" },
    { label: "Cape Verdean", value: "Cape Verdean" },
    { label: "Central African", value: "Central African" },
    { label: "Chadian", value: "Chadian" },
    { label: "Chilean", value: "Chilean" },
    { label: "Chinese", value: "Chinese" },
    { label: "Colombian", value: "Colombian" },
    { label: "Comoran", value: "Comoran" },
    { label: "Congolese", value: "Congolese" },
    { label: "Costa Rican", value: "Costa Rican" },
    { label: "Croatian", value: "Croatian" },
    { label: "Cuban", value: "Cuban" },
    { label: "Cypriot", value: "Cypriot" },
    { label: "Czech", value: "Czech" },
    { label: "Danish", value: "Danish" },
    { label: "Djibouti", value: "Djibouti" },
    { label: "Dominican", value: "Dominican" },
    { label: "Dutch", value: "Dutch" },
    { label: "East Timorese", value: "East Timorese" },
    { label: "Ecuadorean", value: "Ecuadorean" },
    { label: "Egyptian", value: "Egyptian" },
    { label: "Emirian", value: "Emirian" },
    { label: "Equatorial Guinean", value: "Equatorial Guinean" },
    { label: "Eritrean", value: "Eritrean" },
    { label: "Estonian", value: "Estonian" },
    { label: "Ethiopian", value: "Ethiopian" },
    { label: "Fijian", value: "Fijian" },
    { label: "Filipino", value: "Filipino" },
    { label: "Finnish", value: "Finnish" },
    { label: "French", value: "French" },
    { label: "Gabonese", value: "Gabonese" },
    { label: "Gambian", value: "Gambian" },
    { label: "Georgian", value: "Georgian" },
    { label: "German", value: "German" },
    { label: "Ghanaian", value: "Ghanaian" },
    { label: "Greek", value: "Greek" },
    { label: "Grenadian", value: "Grenadian" },
    { label: "Guatemalan", value: "Guatemalan" },
    { label: "Guinea-Bissauan", value: "Guinea-Bissauan" },
    { label: "Guinean", value: "Guinean" },
    { label: "Guyanese", value: "Guyanese" },
    { label: "Haitian", value: "Haitian" },
    { label: "Herzegovinian", value: "Herzegovinian" },
    { label: "Honduran", value: "Honduran" },
    { label: "Hungarian", value: "Hungarian" },
    { label: "I-Kiribati", value: "I-Kiribati" },
    { label: "Icelander", value: "Icelander" },
    { label: "Indian", value: "Indian" },
    { label: "Indonesian", value: "Indonesian" },
    { label: "Iranian", value: "Iranian" },
    { label: "Iraqi", value: "Iraqi" },
    { label: "Irish", value: "Irish" },
    { label: "Israeli", value: "Israeli" },
    { label: "Italian", value: "Italian" },
    { label: "Ivorian", value: "Ivorian" },
    { label: "Jamaican", value: "Jamaican" },
    { label: "Japanese", value: "Japanese" },
    { label: "Jordanian", value: "Jordanian" },
    { label: "Kazakhstani", value: "Kazakhstani" },
    { label: "Kenyan", value: "Kenyan" },
    { label: "Kittian and Nevisian", value: "Kittian and Nevisian" },
    { label: "Kuwaiti", value: "Kuwaiti" },
    { label: "Kyrgyz", value: "Kyrgyz" },
    { label: "Laotian", value: "Laotian" },
    { label: "Latvian", value: "Latvian" },
    { label: "Lebanese", value: "Lebanese" },
    { label: "Liberian", value: "Liberian" },
    { label: "Libyan", value: "Libyan" },
    { label: "Liechtensteiner", value: "Liechtensteiner" },
    { label: "Lithuanian", value: "Lithuanian" },
    { label: "Luxembourger", value: "Luxembourger" },
    { label: "Macedonian", value: "Macedonian" },
    { label: "Malagasy", value: "Malagasy" },
    { label: "Malawian", value: "Malawian" },
    { label: "Malaysian", value: "Malaysian" },
    { label: "Maldivan", value: "Maldivan" },
    { label: "Malian", value: "Malian" },
    { label: "Maltese", value: "Maltese" },
    { label: "Marshallese", value: "Marshallese" },
    { label: "Mauritanian", value: "Mauritanian" },
    { label: "Mauritian", value: "Mauritian" },
    { label: "Mexican", value: "Mexican" },
    { label: "Micronesian", value: "Micronesian" },
    { label: "Moldovan", value: "Moldovan" },
    { label: "Monacan", value: "Monacan" },
    { label: "Mongolian", value: "Mongolian" },
    { label: "Moroccan", value: "Moroccan" },
    { label: "Mosotho", value: "Mosotho" },
    { label: "Motswana", value: "Motswana" },
    { label: "Mozambican", value: "Mozambican" },
    { label: "Namibian", value: "Namibian" },
    { label: "Nauruan", value: "Nauruan" },
    { label: "Nepalese", value: "Nepalese" },
    { label: "New Zealander", value: "New Zealander" },
    { label: "Nicaraguan", value: "Nicaraguan" },
    { label: "Nigerian", value: "Nigerian" },
    { label: "Nigerien", value: "Nigerien" },
    { label: "North Korean", value: "North Korean" },
    { label: "Northern Irish", value: "Northern Irish" },
    { label: "Norwegian", value: "Norwegian" },
    { label: "Omani", value: "Omani" },
    { label: "Pakistani", value: "Pakistani" },
    { label: "Palauan", value: "Palauan" },
    { label: "Panamanian", value: "Panamanian" },
    { label: "Papua New Guinean", value: "Papua New Guinean" },
    { label: "Paraguayan", value: "Paraguayan" },
    { label: "Peruvian", value: "Peruvian" },
    { label: "Polish", value: "Polish" },
    { label: "Portuguese", value: "Portuguese" },
    { label: "Qatari", value: "Qatari" },
    { label: "Romanian", value: "Romanian" },
    { label: "Russian", value: "Russian" },
    { label: "Rwandan", value: "Rwandan" },
    { label: "Saint Lucian", value: "Saint Lucian" },
    { label: "Salvadoran", value: "Salvadoran" },
    { label: "Samoan", value: "Samoan" },
    { label: "San Marinese", value: "San Marinese" },
    { label: "Sao Tomean", value: "Sao Tomean" },
    { label: "Saudi", value: "Saudi" },
    { label: "Scottish", value: "Scottish" },
    { label: "Senegalese", value: "Senegalese" },
    { label: "Serbian", value: "Serbian" },
    { label: "Seychellois", value: "Seychellois" },
    { label: "Sierra Leonean", value: "Sierra Leonean" },
    { label: "Singaporean", value: "Singaporean" },
    { label: "Slovakian", value: "Slovakian" },
    { label: "Slovenian", value: "Slovenian" },
    { label: "Solomon Islander", value: "Solomon Islander" },
    { label: "Somali", value: "Somali" },
    { label: "South African", value: "South African" },
    { label: "South Korean", value: "South Korean" },
    { label: "Spanish", value: "Spanish" },
    { label: "Sri Lankan", value: "Sri Lankan" },
    { label: "Sudanese", value: "Sudanese" },
    { label: "Surinamer", value: "Surinamer" },
    { label: "Swazi", value: "Swazi" },
    { label: "Swedish", value: "Swedish" },
    { label: "Swiss", value: "Swiss" },
    { label: "Syrian", value: "Syrian" },
    { label: "Taiwanese", value: "Taiwanese" },
    { label: "Tajik", value: "Tajik" },
    { label: "Tanzanian", value: "Tanzanian" },
    { label: "Thai", value: "Thai" },
    { label: "Togolese", value: "Togolese" },
    { label: "Tongan", value: "Tongan" },
    { label: "Trinidadian or Tobagonian", value: "Trinidadian or Tobagonian" },
    { label: "Tunisian", value: "Tunisian" },
    { label: "Turkish", value: "Turkish" },
    { label: "Tuvaluan", value: "Tuvaluan" },
    { label: "Ugandan", value: "Ugandan" },
    { label: "Ukrainian", value: "Ukrainian" },
    { label: "Uruguayan", value: "Uruguayan" },
    { label: "Uzbekistani", value: "Uzbekistani" },
    { label: "Venezuelan", value: "Venezuelan" },
    { label: "Vietnamese", value: "Vietnamese" },
    { label: "Welsh", value: "Welsh" },
    { label: "Yemenite", value: "Yemenite" },
    { label: "Zambian", value: "Zambian" },
    { label: "Zimbabwean", value: "Zimbabwean" },
  ];
}

export const formatNumber = (num) => {
  if (num === "" || num === null || num === undefined) return "";

  // Convert to string and remove all characters except digits and dot
  num = num.toString().replace(/[^0-9.]/g, "");

  // Split integer and decimal part (if any)
  let [intPart, decimalPart] = num.split(".");

  // Default decimal part to "00"
  decimalPart = decimalPart ? decimalPart.slice(0, 2).padEnd(2, "0") : "00";

  // Format integer part (Indian style)
  if (intPart.length > 3) {
    let lastThree = intPart.slice(-3);
    let otherDigits = intPart.slice(0, -3);
    otherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
    intPart = otherDigits + "," + lastThree;
  }

  return `${intPart}.${decimalPart}`;
};

export function numberToWords(num) {
  if (num === 0) return "Zero only";

  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  const b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  function inWords(n) {
    let str = "";
    if (n > 19) {
      str += b[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + a[n % 10] : "");
    } else {
      str += a[n];
    }
    return str.trim();
  }

  let output = "";

  let crore = Math.floor(num / 10000000);
  if (crore > 0) {
    output += inWords(crore) + " Crore ";
    num %= 10000000;
  }

  let lakh = Math.floor(num / 100000);
  if (lakh > 0) {
    output += inWords(lakh) + " Lakh ";
    num %= 100000;
  }

  let thousand = Math.floor(num / 1000);
  if (thousand > 0) {
    output += inWords(thousand) + " Thousand ";
    num %= 1000;
  }

  let hundred = Math.floor(num / 100);
  if (hundred > 0) {
    output += inWords(hundred) + " Hundred ";
    num %= 100;
  }

  if (num > 0) {
    output += (output !== "" ? "and " : "") + inWords(num);
  }

  output = output.trim();

  // Convert to lowercase and make only the first word capitalized
  output = output.toLowerCase();
  output = output.charAt(0).toUpperCase() + output.slice(1);

  return output + " only";
}

export const getSubType = (subType) => {
  const leaveSubType = [
    {
      label: "Full Day",
      value: "full_day",
    },
    {
      label: "First Half",
      value: "first_half",
    },
    {
      label: "Second Half",
      value: "second_half",
    },
    {
      label: "Short Leave",
      value: "short_leave",
    },
  ];
  const selectedType = leaveSubType.filter((sub) => {
    return sub.value === subType;
  });
  return selectedType[0]?.label;
};
